import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-copy-right',
  templateUrl: './copy-right.component.html',
  styleUrls: ['./copy-right.component.css']
})
export class CopyRightComponent implements OnInit {

  date = new Date();
  annee;

  constructor() {
    this.annee = this.date.getFullYear();
   }

  ngOnInit(): void {
  }

}
